import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const Nuts = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [nutUrl, setNutUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    type: "hex",
    nominal_d: "",
    pitch: "",
    height: "",
  });

  // Redirect if not signed in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Load model-viewer library
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate Nut STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/nutdesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          type: inputs.type,
          nominal_d: parseFloat(inputs.nominal_d),
          pitch: parseFloat(inputs.pitch),
          height: parseFloat(inputs.height),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setNutUrl(data.nuturl || "");
        alert("Nut design generated successfully!");
      } else {
        console.error("Error sending nut data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/NuttoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting Nut to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Nut Design</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        <label>Nut Type:</label>
        <select
          name="type"
          value={inputs.type}
          onChange={handleChange}
          className="w-full p-2 border rounded"
        >
          <option value="hex">Hex</option>
          <option value="square">Square</option>
          <option value="flange">Flange</option>
          <option value="cap">Cap</option>
          <option value="round-knurled">Round Knurled</option>
        </select>
        <br /><br />

        <input
          type="number"
          name="nominal_d"
          value={inputs.nominal_d}
          onChange={handleChange}
          placeholder="Nominal Diameter (mm)"
          required
          className="w-full p-2 border rounded"
        />
        <br /><br />

        <input
          type="number"
          name="pitch"
          value={inputs.pitch}
          onChange={handleChange}
          placeholder="Pitch (mm)"
          required
          className="w-full p-2 border rounded"
        />
        <br /><br />

        <input
          type="number"
          name="height"
          value={inputs.height}
          onChange={handleChange}
          placeholder="Height (mm)"
          required
          className="w-full p-2 border rounded"
        />
        <br /><br />

        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Nut File Path: {nutUrl}</p>

      {nutUrl && (
        <>
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
          <br /><br />
          <a href={nutUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Nut Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Nut model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{
              width: "600px",
              height: "400px",
              backgroundColor: "lightgray",
            }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Nuts;
